import { AuthService } from 'src/app/shared/services/auth.service';
import { Injectable, isDevMode } from '@angular/core';
import { CanLoad, Router, Route, UrlSegment, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AlreadyLoggedInGuard implements CanLoad {

  constructor(
    private router: Router,
    private authService: AuthService,
  ) {}

  canLoad(
    route: Route,
    segments: UrlSegment[]): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if(isDevMode())console.log('segments',segments)
    // if(segments.length > 1){
    //   if(segments[1].path == 'creatucuenta')return true
    // }
    if(!this.authService.isLoggedIn()) { return true; 
    }else{

      this.router.navigateByUrl('/lost');

  //    return false;

    }
    
  }
}
